import { Alert, Button } from '@mui/material';
import { useSections } from '../section-context';

export function SectionRefreshNotice() {
  const { error, refresh } = useSections();
  if (!error) return null;
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" onClick={() => void refresh()}>
          Повторить
        </Button>
      }
    >
      Не удалось обновить разделы. Показаны последние загруженные настройки. {error}
    </Alert>
  );
}
